import { TicketsService } from "@/services";
import dayjs from "@/utiles/dayjs";

export default {
  name: "dashboard-tickets-card",
  components: {},
  props: [],
  data() {
    return {
      tickets: null,
      dashboardTicketLoader: true
    };
  },
  filters: {
    fromNowDate(date) {
      return dayjs(date)
        .startOf(date)
        .fromNow();
    }
  },
  computed: {},
  mounted() {
    this.getOrdersData();
  },
  methods: {
    getOrdersData() {
      TicketsService.getTickets({
        page: 1
      })
        .then(response => {
          this.tickets = response.data.data;
        })
        .finally(() => {
          this.dashboardTicketLoader = false;
        });
    },
    redirectToTicket(ticket) {
      this.$router.push({ path: `/tickets/${ticket.id}` });
    }
  }
};
